import React from 'react'

export type headerResizeHandler = (key: string, width: number) => void

interface Props {
  onResize: headerResizeHandler
  onResizeCommit: headerResizeHandler
  headerKey: string
}

interface State {
  isResizing: boolean
  previousX: number
}

class CellResizer extends React.PureComponent<Props, State> {
  state = {
    isResizing: false,
    previousX: 0
  }

  setPreviousX = (previousX: number) => {
    this.setState(previousState => ({
      ...previousState,
      previousX
    }))
  }

  setIsResizing = (isResizing: boolean) => {
    this.setState(previousState => ({
      ...previousState,
      isResizing
    }))
  }

  onMouseMove = (event: MouseEvent) => {
    const { isResizing, previousX } = this.state

    if (isResizing) {
      this.props.onResize(this.props.headerKey, event.clientX - previousX)
      this.setPreviousX(event.clientX)
    }
  }

  onMouseUp = (event: MouseEvent) => {
    const { isResizing, previousX } = this.state

    if (isResizing) {
      this.props.onResizeCommit(this.props.headerKey, event.clientX - previousX)
      this.setIsResizing(false)
    }
  }

  onMouseDown = (event: React.MouseEvent) => {
    const leftMouseButton = 0

    if (event.button === leftMouseButton) {
      this.setPreviousX(event.clientX)
      this.setIsResizing(true)
    }
  }

  componentDidMount() {
    window.addEventListener('mousemove', this.onMouseMove)
    window.addEventListener('mouseup', this.onMouseUp)
  }

  componentWillUnmount() {
    window.removeEventListener('mousemove', this.onMouseMove)
    window.removeEventListener('mouseup', this.onMouseUp)
  }
  render() {
    return <span className='cbgms-grid__resizer' onMouseDown={this.onMouseDown} />
  }
}

export default CellResizer
